import { Dropdown } from 'antd';
import { NotificationContent } from 'features/notification/components/NotificationPanel/NotificationContent';
import { memo, type PropsWithChildren, useState } from 'react';

export const NotificationDropdown = memo(({ children }: PropsWithChildren) => {
  const [open, setOpen] = useState(false);

  return (
    <Dropdown
      open={open}
      onOpenChange={setOpen}
      trigger={['click']}
      dropdownRender={() => (
        <div className="w-85 rounded-[20px] rounded-se-none bg-white p-5 shadow-[0px_4px_40px_0px_rgba(0,0,0,0.15)]">
          <NotificationContent onClose={() => setOpen(false)} />
        </div>
      )}
    >
      {children}
    </Dropdown>
  );
});
